import React from 'react';
import classNames from 'classnames';

import '../index.scss';

const voiceItems = [
  {
    title: 'Transf. Ramal',
    icon: 'icon_ramal',
    type: 'VoiceTransferirRamalInternoExterno',
    enabled: true,
  },
  {
    title: 'Tocar Áudio',
    icon: 'icon_asr',
    type: 'VoiceTTSAudio',
    enabled: true,
  },
  // {
  //   title: 'Venda',
  //   icon: 'icon_carrinho',
  //   type: 'VoiceConfirmarVenda',
  //   enabled: true,
  // },
  {
    title: 'Áudio + Recon. de Voz',
    icon: 'icon_asr',
    type: 'VoiceTTSAudioASR',
    enabled: true,
  },
  {
    title: 'Finalizar Atendimento',
    icon: 'icon_email',
    type: 'VoiceFinalizarAtendimento',
    enabled: true,
  },
  {
    title: 'Trans. Operador',
    icon: 'icon_humano',
    type: 'VoiceTransferirRamalLocalizadorVendedor',
    enabled: true,
  },
  {
    title: 'Agendar Ligação',
    icon: 'icon_agendar',
    type: 'VoiceAgendarMailing',
    enabled: true,
  },
  {
    title: 'Áudio + Reconh. de Dígitos',
    icon: 'icon_dtmf',
    type: 'VoiceTTSAudioDTMF',
    enabled: true,
  },
  {
    title: 'API',
    icon: 'icon_webservice',
    type: 'VoiceWebApiList',
    enabled: true,
  },
  {
    title: 'Enviar SMS',
    icon: 'icon_sms',
    type: 'VoiceSMS',
    enabled: true,
  },
  // {
  //   title: 'Pesquisar',
  //   icon: 'icon_formulario',
  //   type: 'VoicePesquisarMailing',
  //   enabled: true,
  // },
  // {
  //   title: 'Inserir Mailing',
  //   icon: 'icon_email',
  //   type: 'VoiceInserirMailing',
  //   enabled: true,
  // },
  // {
  //   title: 'Email',
  //   icon: 'icon_email',
  //   type: 'VoiceEmail',
  //   enabled: true,
  // },

  // {
  //   title: 'Pular STEP',
  //   icon: 'icon_pulo_step',
  //   type: 'VoicePularStep',
  //   enabled: true,
  // },
];

const MenuItem = ({ item, handleClick }) => (
  <li className="builder__context__menu-item">
    <a
      className={classNames({
        disabled: !item.enabled,
      })}
      onClick={(e) => handleClick(e, item)}
      href="#/"
    >
      {item.icon ? (
        <img src={`/assets/images/icons/${item.icon}.svg`} alt="" />
      ) : null}
      <span>{item.title}</span>
    </a>
  </li>
);

export default ({ style, handleItemClick }) => {
  return (
    <div className="builder__context" style={{ ...style }}>
      <div className="builder__context--position">
        <div className="builder__context__arrow" />
        <ul className="builder__context__items">
          <p className="title-bloco-items">Selecione o bloco</p>
          {voiceItems.map((item) => (
            <MenuItem
              handleClick={handleItemClick}
              item={item}
              key={item.type}
            />
          ))}
        </ul>
      </div>
    </div>
  );
};
